module.exports = __webpack_public_path__ + "img/identification.341ab66d.svg";